<div
  class="mt-16 md:mt-[10rem] mx-auto container mb-8 md:mb-[5rem] px-4 md:px-6"
>
  <shared-arrow-back></shared-arrow-back>
  @if(!hasIssue() && currentStatus() === 24){
  <div class="flex justify-end">
    <request-claim (loadEventE)="reclaimOrder()"></request-claim>
  </div>
  }@else if (currentStatus() === 24) {
  <reclaim-order [orderId]="orderId"></reclaim-order>
  } @defer (when loadStatusReclaim()) { @if(currentStatus() !== 24 &&
  currentStatus() !== 39 && currentStatus() !== 28){
  <code-verification [orderId]="orderId"></code-verification>
  } } @placeholder { }
  <!-- Layout responsive: 1 columna en móvil, 2 en desktop -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 h-fit">
    <!-- Primera columna: Stepper y productos -->

    <div class="flex flex-col gap-4 order-1 lg:order-1">
      <!-- Stepper -->

      @defer (when orderNumber) { @if(currentStatus() ===39 || currentStatus()
      === 28){
      <orden-canceled [reasonCancel]="reasonCancel"></orden-canceled>
      }@else {
      <div class="flex-shrink-0">
        <stepper [orderStatus]="currentStatus()"></stepper>
      </div>
      } } @placeholder {
      <!-- Skeleton para el stepper -->
      <div class="flex-shrink-0">
        <div class="bg-white rounded-lg shadow-sm p-4 animate-pulse">
          <div class="flex items-center justify-between mb-4">
            <div class="h-4 bg-gray-200 rounded w-1/4"></div>
            <div class="h-3 bg-gray-200 rounded w-16"></div>
          </div>
          <div class="flex items-center space-x-4">
            <div class="flex-shrink-0">
              <div class="w-8 h-8 bg-gray-200 rounded-full"></div>
            </div>
            <div class="flex-1">
              <div class="h-2 bg-gray-200 rounded w-full mb-2"></div>
              <div class="h-2 bg-gray-200 rounded w-3/4"></div>
            </div>
          </div>
          <div class="flex items-center space-x-4 mt-4">
            <div class="flex-shrink-0">
              <div class="w-8 h-8 bg-gray-200 rounded-full"></div>
            </div>
            <div class="flex-1">
              <div class="h-2 bg-gray-200 rounded w-full mb-2"></div>
              <div class="h-2 bg-gray-200 rounded w-2/3"></div>
            </div>
          </div>
          <div class="flex items-center space-x-4 mt-4">
            <div class="flex-shrink-0">
              <div class="w-8 h-8 bg-gray-200 rounded-full"></div>
            </div>
            <div class="flex-1">
              <div class="h-2 bg-gray-200 rounded w-full mb-2"></div>
              <div class="h-2 bg-gray-200 rounded w-1/2"></div>
            </div>
          </div>
        </div>
      </div>
      } @loading {
      <!-- Loading state mientras se evalúa la condición -->
      <div class="flex-shrink-0">
        <div class="bg-white rounded-lg shadow-sm p-4">
          <div class="flex items-center justify-center">
            <div
              class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"
            ></div>
            <span class="ml-2 text-gray-600"
              >Cargando estado del pedido...</span
            >
          </div>
        </div>
      </div>
      }
      <!-- Lista de productos -->
      <div class="flex-1">
        @defer {
        <list-products-order [orderDetail]="orderNumber"></list-products-order>
        } @placeholder {
        <div class="p-4 text-center text-gray-500">Loading...</div>
        }
      </div>
    </div>

    <!-- Segunda columna: Info de pago -->
    <div class="flex flex-col gap-4 order-2 lg:order-2">
      <!-- Info de pago -->
      <div class="flex-1">
        <info-payment
          [infoPayment]="infoPayment"
          [isLoading]="isLoading()"
        ></info-payment>
      </div>

      <!-- Chat en móvil va después del pago -->
      @if(showMap()){
      <div class="flex-1 lg:hidden">
        <chat-cli-rep
          [orderId]="orderId"
          [picture_delivery]="picture_delivery"
        ></chat-cli-rep>
      </div>
      }
    </div>

    <!-- Mapa: En móvil va al final, en desktop en la primera columna -->
    @if(showMap()){
    <div class="flex-1 order-4 lg:order-3 lg:col-start-1 lg:h-[600px]">
      <detail-order-map-tracking
        [coordenadasOrigen]="coordenadasOrigen"
        [coordenadasDestino]="coordenadasDestino"
        [orderId]="orderId"
        (statusChange)="onStatusChange($event)"
      ></detail-order-map-tracking>
    </div>
    }

    <!-- Chat en desktop: va en la segunda columna -->
    @if(showMap()){
    <div
      class="hidden lg:block flex-1 order-5 lg:order-4 lg:col-start-2 lg:h-[600px]"
    >
      <chat-cli-rep [orderId]="orderId"></chat-cli-rep>
    </div>
    }
  </div>
</div>

@if(currentStatus() === 24 && (!comments.isCommentDelivery ||
!comments.isCommentEstablishment)){
<detail-order-modal-view-rate [data]="comments"></detail-order-modal-view-rate>
} @if ( currentStatus() === 25) {
<shared-timer [endTimer]="600" [isOpen]="showTimer()"></shared-timer>
} @if(currentStatus() === 24){
<div class="m-3">
  <p
    (click)="openModal()"
    class="text-center text-md font-bold text-gray-500 hover:text-gray-800 cursor-pointer"
  >
    ¿Desea facturar el pedido?
  </p>
</div>

<facturar (openModal)="openModal()" #facturarModal></facturar>
}
